import { render, staticRenderFns } from "./Adjustments.vue?vue&type=template&id=445f2c3a&"
import script from "./Adjustments.vue?vue&type=script&lang=ts&"
export * from "./Adjustments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports